var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":_vm.content,"variant":_vm.variant,"size":"sm"},on:{"click":_vm.handleClick}},[_c('feather-icon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }